import React from 'react';
import ReactDOM from 'react-dom';
import './MyMapsFooter.css';
import * as helpers from '../../../helpers/helpers';
import FloatingMenu, {
  FloatingMenuItem,
} from '../../../helpers/FloatingMenu.jsx';
import Portal from '../../../helpers/Portal.jsx';
import { SubMenu, Item as MenuItem, Divider } from 'rc-menu';

const MyMapsFooter = (props) => {
  // USE HOOKS
  //const [activeColor, setActiveColor] = useState("#e809e5");
  //const [activeColor, setActiveColor] = useState(props.activeColor);

  // PARENT CHANGES THE COLOR FROM STORAGE
  //useEffect(() => {});
  function onToolsClick(evt) {
    var evtClone = Object.assign({}, evt);
    const menu = (
      <Portal>
        <FloatingMenu
          autoY={true}
          key={helpers.getUID()}
          buttonEvent={evtClone}
          onMenuItemClick={props.onMenuItemClick}
          classNamesToIgnore={[
            'fs-mymaps-footer-button',
            'fs-mymaps-footer-buttons-img',
          ]}
        >
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-show-all"
          >
            <FloatingMenuItem
              imageName={'checkbox_on.png'}
              label="Prikaži mape"
            />
          </MenuItem>
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-hide-all"
          >
            <FloatingMenuItem
              imageName={'checkbox_off.png'}
              label="Sakrij mape"
            />
          </MenuItem>
          <Divider />
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-delete-selected"
          >
            <FloatingMenuItem
              imageName={'eraser.png'}
              label="Izbriši označene"
            />
          </MenuItem>
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-delete-unselected"
          >
            <FloatingMenuItem
              imageName={'eraser.png'}
              label="Izbriši neoznačene"
            />
          </MenuItem>
          <MenuItem
            className="fs-floating-menu-toolbox-menu-item"
            key="fs-floating-menu-merge-polygons"
          >
            <FloatingMenuItem
              imageName={'merge_polygon.png'}
              label="Sjedini poligone"
            />
          </MenuItem>
          <SubMenu title="Spremi kao...">
            <MenuItem
              className="fs-floating-menu-toolbox-menu-item"
              key="fs-floating-menu-export-all-to-kml"
            >
              <FloatingMenuItem label="KML" />
            </MenuItem>
            <MenuItem
              className="fs-floating-menu-toolbox-menu-item"
              key="fs-floating-menu-export-all-to-esrijson"
            >
              <FloatingMenuItem label="EsriJSON" />
            </MenuItem>
            <MenuItem
              className="fs-floating-menu-toolbox-menu-item"
              key="fs-floating-menu-export-all-to-geojson"
            >
              <FloatingMenuItem label="GeoJSON" />
            </MenuItem>
          </SubMenu>
        </FloatingMenu>
      </Portal>
    );

    ReactDOM.render(menu, document.getElementById('portal-root'));
  }

  return (
    <div className="fs-mymaps-footer-buttons">
      <button
        className="fs-button fs-mymaps-footer-button delete"
        onClick={props.onDeleteAllClick}
      >
        Izbriši sve
      </button>
      <button
        className="fs-button fs-mymaps-footer-button tools"
        onClick={onToolsClick}
      >
        Dodatni alati
      </button>
    </div>
  );
};

export default MyMapsFooter;
